import { CopyLinkButton } from './CopyLinkButton';
import { briefPortalUrl } from './shareLinks';

/**
 * The CEO Brief's public copy control.
 *
 * It accepts the bearer token, not a URL. The only URL it can copy is the
 * public /brief/:token route built by shareLinks.ts, so a caller cannot hand
 * it the signed-in /ceo-brief route that caused the September incident.
 */
export function BriefCopyLinkButton({
  token,
  label = 'Copy link',
  className = '',
}: {
  token: string;
  label?: string;
  className?: string;
}) {
  return (
    <CopyLinkButton
      url={briefPortalUrl(window.location.origin, token)}
      label={label}
      className={className}
    />
  );
}
